import { useQuery } from '@tanstack/react-query';
import { getResourceStatus, ResourceStatusResponse } from '../api/resourceStatus';

/**
 * Polls GET /v1/resources/status every 30s for the given ARNs.
 * Returns a merged map of healthy resources + error resources.
 */
export function useResourceStatus(arns: string[], enabled = true) {
  return useQuery<ResourceStatusResponse>({
    queryKey: ['resource-status', ...[...arns].sort()],
    queryFn: () => getResourceStatus(arns),
    enabled: enabled && arns.length > 0,
    refetchInterval: 30_000,
    staleTime: 25_000,
  });
}
